
import Vue, { PropType } from 'vue';
import Home16 from '@carbon/icons-vue/es/home/16';
import Image16 from '@carbon/icons-vue/es/image/16';
import TextCreation16 from '@carbon/icons-vue/es/text--creation/16';
import IconTextButton from '../Buttons/IconTextButton.vue';

export default Vue.extend({
  name: 'ActionsToolbar',

  components: { IconTextButton },

  data() {
    return {
      Home16: Home16,
      Image16: Image16,
      TextCreation16: TextCreation16,
    };
  },
});
